import React from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import CustomTextField from '../../Dispatch/RouteExecution/DriverPopUp/common/CustomTextField';
import { SEARCH_INPUT_NUMBER_VALIDATION } from '../../Reports/RecordsLookup/constants';

const SearchBox = ({
  value,
  onChange,
  onSearch,
  loading,
  disabled,
  classes = {},
  autoFocus = false,
  inputLabel = 'Pro number',
  inputProps = null
}) => (
  <div className={classes.searchContainer}>
    <div className={classes.searchBoxWrapper}>
      <div className={classes.fullInputBox}>
        <CustomTextField
          className={classes.fullWidth}
          id="ProNumber"
          handleChange={onChange}
          value={value}
          error={null}
          label={inputLabel}
          mainClassProps={{ marginNormal: classes.marginNormal }}
          InputPropsClasses={{ input: classes.inputField }}
          labelClassProps={{ root: classes.labelClass }}
          inputProps={inputProps || SEARCH_INPUT_NUMBER_VALIDATION}
          autoFocus={autoFocus}
        />
      </div>
    </div>
    <Button
      color="primary"
      variant="contained"
      disabled={loading || disabled || !value}
      classes={{ root: classes.button, disabled: classes.disabledButton }}
      onClick={onSearch}
      >
      {loading ? (
        <CircularProgress size={16} classes={{ root: classes.circularProgress }} />
      ) : (
        'Search'
      )}
    </Button>
  </div>
);

export default SearchBox;
